import React from "react";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import { ContainerR, TextFooter, Image, ContainerImage } from "./styles";
import useScreenSize from "../../Hooks/useScreenSize";

export const Footer = ({ style, styleText }) => {
  const { width } = useScreenSize();
  const getSlidesPerView = () => {
    if (width <= 768) return 3;
    else if (width <= 1024) return 4;
    else if (width <= 1440) return 6;
    else return 8;
  };

  return (
    <ContainerR style={style}>
      <TextFooter style={styleText}>¡Nos unimos para ayudarte! </TextFooter>
      <Swiper
        slidesPerView={getSlidesPerView()}
        spaceBetween={50}
        centeredSlides={true}
        freeMode={true}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, FreeMode, Pagination]}
        style={{ width: "95%" }}
      >
        <SwiperSlide>
          <ContainerImage>
            <Image src="/Logo.png" />
          </ContainerImage>
        </SwiperSlide>
        <SwiperSlide>
          <ContainerImage>
            <Image src="/ColvenzLogo.png" />
          </ContainerImage>
        </SwiperSlide>
        <SwiperSlide>
          <ContainerImage>
            <Image src="/logos_gobernacion.png" />
          </ContainerImage>
        </SwiperSlide>
      </Swiper>
    </ContainerR>
  );
};

Footer.propTypes = {
  left: PropTypes.bool,
  style: PropTypes.object,
  styleText: PropTypes.object,
};
